import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';
import { Sheet } from 'react-modal-sheet';
import { Link } from 'react-router';
import { formatMiniAppLink } from '@/utils/mini-app-link';
import groovyWalkAnimation from '../../../assets/lottie/./Success.json';
type Props = { isOpen: boolean; onClose: () => void };

export const ModalSuccess = ({ isOpen, onClose }: Props) => {
    const { t } = useTranslation();

    return (
        <Sheet isOpen={isOpen} onClose={onClose} detent="content-height">
            <Sheet.Backdrop className="!bg-transparent3" onTap={onClose} />

            <Sheet.Container className="!bg-transparent p-4  mb-2 flex !flex-col justify-end">
                <Sheet.Content className="h-fit !bg-transparent flex !flex-col justify-end z-50">
                    <div className=" !bg-[#141414] p-6 rounded-2xl shadow-lg">
                        <div className="flex justify-between items-center">
                            <p className="text-white text-2xl">Transaction</p>
                            <button onClick={onClose} className="p-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M6 6L18 18"
                                        stroke="#C1C4CE"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M18 6L6 18"
                                        stroke="#C1C4CE"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div className="flex items-center justify-center p-4">
                            <Lottie
                                animationData={groovyWalkAnimation}
                                loop={false}
                                className="w-[88px] h-[88px]"
                            />
                        </div>

                        <p className="text-white text-center">
                            {t('1 AION has been sent to your wallet')}
                        </p>

                        <Link
                            to={formatMiniAppLink('https://worldcoin.org/mini-app/?app_id=app_0d4b759921490adc1f2bd569fda9b53a')}
                            target="_blank"
                            onClick={onClose}
                            className=" text-center flex justify-center w-full mt-6 bg-white rounded-lg py-2"
                        >
                            <p className="text-center text-black font-medium">
                                {t('Go to Holdstation Wallet')}
                            </p>
                        </Link>
                    </div>
                </Sheet.Content>
            </Sheet.Container>
        </Sheet>
    );
};
